import {
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { DialogoConfirmacion } from "../../basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import LoadingBackdrop from "../../basicsComponents/LoadingBackdrop/LoadingBackdrop";
import CustomDesplegable from "../../basicsComponents/CustomDesplegable/CustomDesplegable";
import CustomInput from "../../basicsComponents/CustomInput/CustomInput";
import { Row } from "../../basicsComponents/MaterialGridComponents";
import { useHistory } from "react-router";

const ModalPacienteForm = ({
  openModal,
  setOpenModal,
  mostrarNotificacion,
  paciente,
  setPaciente,
}) => {
  const [cargando, setCargando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [celular, setCelular] = useState("");
  const [nroDocumento, setNroDocumento] = useState("");
  const [tiposDoc, setTiposDoc] = useState([]);
  const [mutuales, setMutuales] = useState([]);
  const [mutualAfiliado, setMutualAfiliado] = useState("");
  const [tipoDoc, setTipoDoc] = useState(-1);
  const [mutual, setMutual] = useState(-1);
  const [errores, setErrores] = useState({
    nombre: false,
    apellido: false,
    correo: false,
    fechaNac: false,
    fechaSelect: false,
    celular: false,
    nroDocumento: false,
    mutualAfiliado: false,
    tipoDoc: false,
    mutual: false,
  });
  const [abrirModalCancelarRegistro, setAbrirModalCancelarRegistro] =
    useState(false);
  const [abrirDesplegableTiposDoc, setAbrirDesplegableTiposDoc] =
    useState(false);
  const [abrirDesplegableMutuales, setAbrirDesplegableMutuales] =
    useState(false);
  const history = useHistory();
  // agregar metodos modal confirmacion y cierre de ventana
  const [abrirDialogoReiniciarSesion, setAbrirDialogoReiniciarSesion] =
    useState(false);

  const traerTiposDocs = async () => {
    let tiposDocs = null;
    const url = localStorage.getItem("urlAxioPP");
    if (!url) {
      mostrarNotificacion(
        true,
        "No se encontro la URL de API (urlAxioPP). Contacte a soporte.",
        "rojo",
      );
      setTiposDoc([]);
      return;
    }

    try {
      const response = await axios.get(`${url}Pacientes/DocumentoTipoTraer`);
      if (response.data.length !== 0) {
        tiposDocs = response.data;
      } else {
        tiposDocs = null;
      }

      tiposDocs = tiposDocs.map((tipoDoc) => {
        return {
          ...tipoDoc,
          text: tipoDoc.nombre,
        };
      });

      setTiposDoc(tiposDocs);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar los tipos de documentos",
        "rojo",
      );
    }
  };

  const traerMutuales = async () => {
    let mutuales = null;
    const url = localStorage.getItem("urlAxioPP");
    if (!url) {
      mostrarNotificacion(
        true,
        "No se encontro la URL de API (urlAxioPP). Contacte a soporte.",
        "rojo",
      );
      setMutuales([]);
      return;
    }

    try {
      const response = await axios.get(`${url}Mutuales`);
      if (response.data.length !== 0) {
        mutuales = response.data;
      } else {
        mutuales = null;
      }

      mutuales = mutuales.filter(
        (mutual) => mutual?.vigente === undefined || mutual?.vigente === true,
      );

      mutuales = mutuales.map((mutual) => {
        return {
          ...mutual,
          text: mutual.nombre,
        };
      });

      setMutuales(mutuales);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar las mutuales registradas",
        "rojo",
      );
    }
  };

  const cargarCatalogos = async () => {
    setCargando(true);
    try {
      await Promise.all([traerTiposDocs(), traerMutuales()]);
    } finally {
      setCargando(false);
    }
  };

  const limpiarCampos = () => {
    setNombre("");
    setApellido("");
    setFechaNac("");
    setTipoDoc(-1);
    setNroDocumento("");
    setMutual(-1);
    setMutualAfiliado("");
    setCelular("");
    setCorreo("");
  };

  useEffect(() => {
    if (openModal && (mutuales.length === 0 || tiposDoc.length === 0)) {
      cargarCatalogos();
    }
    if (paciente?.codigo && mutuales.length !== 0 && openModal) {
      setNombre(paciente.nombre);
      setApellido(paciente.apellido);
      setCorreo(paciente.email);

      // Convertir la fecha del backend (yyyy-mm-dd) a dd/mm/yyyy.
      // Si el backend no trae fecha, evitar crash y dejar el campo vacío.
      const nacimientoBackend =
        typeof paciente.nacimiento === "string" ? paciente.nacimiento : "";
      const fechaBackend = nacimientoBackend.includes("T")
        ? nacimientoBackend.split("T")[0]
        : nacimientoBackend;
      const partesFecha = fechaBackend.split("-");
      const fechaFormateada =
        partesFecha.length === 3
          ? `${partesFecha[2]}/${partesFecha[1]}/${partesFecha[0]}`
          : "";

      setFechaNac(fechaFormateada);

      setCelular(paciente.celular);
      setNroDocumento(paciente.documentoNro);
      setMutualAfiliado(paciente.mutualAfiliado);
      setTipoDoc(paciente.documentoTipo);
      setMutual(paciente.mutual);
    }
    if (!openModal) {
      limpiarCampos();
    }
  }, [openModal, paciente, mutuales, tiposDoc]);

  const handleChangeSelect = (value, select) => {
    switch (select) {
      case "Obra social":
        setMutual(value);
        setErrores((prev) => ({
          ...prev,
          mutual: false,
          mutualAfiliado: false,
        }));
        if (Number(value) === 1) {
          setMutualAfiliado("-");
        } else if (mutualAfiliado === "-") {
          setMutualAfiliado("");
        }
        break;
      case "Tipo Documento":
        setTipoDoc(value);
        setErrores((prev) => ({ ...prev, tipoDoc: false }));
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  const validarFormatoFecha = (fecha) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(fecha || "")) return false;

    const [dia, mes, anio] = fecha.split("/").map(Number);
    const fechaObjeto = new Date(anio, mes - 1, dia);
    const coincideFormato =
      fechaObjeto.getFullYear() === anio &&
      fechaObjeto.getMonth() === mes - 1 &&
      fechaObjeto.getDate() === dia;
    const noEsFutura = fechaObjeto <= new Date();

    return coincideFormato && noEsFutura;
  };

  const convertirFormatoFechaAISO = (fecha) => {
    if (!validarFormatoFecha(fecha)) return "";
    const [dia, mes, anio] = fecha.split("/");
    return `${anio}-${mes}-${dia}`;
  };

  const convertirFormatoFechaAMesDiaAnio = (fecha) => {
    if (!validarFormatoFecha(fecha)) return "";
    const [dia, mes, anio] = fecha.split("/");
    return `${mes}/${dia}/${anio}`;
  };

  const getTextoDesplegableSeleccionado = (array, codigo) => {
    const elemento = array.find((item) => item.codigo === codigo);
    return elemento?.text || "";
  };

  const validarFormRegistroPaciente = () => {
    let pasa = true;
    let errors = {};
    const emailRegex =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
    if (nombre === "" || nombre === null || nombre === undefined) {
      pasa = false;
      errors.nombre = true;
    }
    if (apellido === "" || apellido === null || apellido === undefined) {
      pasa = false;
      errors.apellido = true;
    }
    if (fechaNac === "" || fechaNac === null || fechaNac === undefined) {
      pasa = false;
      errors.fechaNac = true;
    }
    if (celular === "" || celular === null || celular === undefined) {
      pasa = false;
      errors.celular = true;
    }
    if (
      nroDocumento === "" ||
      nroDocumento === null ||
      nroDocumento === undefined
    ) {
      pasa = false;
      errors.nroDocumento = true;
    }
    if (
      correo === "" ||
      correo === null ||
      correo === undefined ||
      !emailRegex.test(correo)
    ) {
      pasa = false;
      errors.correo = true;
    }
    if (tipoDoc === null || tipoDoc === undefined || tipoDoc === -1) {
      pasa = false;
      errors.tipoDoc = true;
    }
    if (mutual === null || mutual === undefined || mutual === -1) {
      pasa = false;
      errors.mutual = true;
    }
    if (mutual !== -1 && Number(mutual) !== 1 && !mutualAfiliado?.trim()) {
      pasa = false;
      errors.mutualAfiliado = true;
    }
    if (!validarFormatoFecha(fechaNac)) {
      pasa = false;
      errors.fechaNac = true;
    }

    setError(Boolean(errors.fechaNac));
    setErrores(errors);
    return pasa;
  };

  const obtenerCredencialesAppHC = () => {
    const usuario =
      process.env.REACT_APP_APPHC_USER ||
      localStorage.getItem("appHCUser") ||
      localStorage.getItem("AppHCUser");
    const password =
      process.env.REACT_APP_APPHC_PASS ||
      localStorage.getItem("appHCPass") ||
      localStorage.getItem("AppHCPass");

    return { usuario, password };
  };

  const ensureAppHCToken = async (url, forceRefresh = false) => {
    if (!forceRefresh) {
      const tokenActual = sessionStorage.getItem("AppHCToken");
      if (tokenActual) return tokenActual;
    }

    const { usuario, password } = obtenerCredencialesAppHC();
    if (!usuario || !password) {
      throw new Error(
        "Faltan credenciales tecnicas para obtener AppHCToken. Configure REACT_APP_APPHC_USER/REACT_APP_APPHC_PASS o appHCUser/appHCPass en localStorage.",
      );
    }

    const response = await axios.post(`${url}Usuarios/Login`, {
      nombreUsuario: usuario,
      password,
    });
    const nuevoToken = response?.data?.token;
    if (!nuevoToken) {
      throw new Error("No se pudo obtener AppHCToken desde Usuarios/Login.");
    }

    sessionStorage.setItem("AppHCToken", nuevoToken);
    return nuevoToken;
  };

  const registrarPaciente = async () => {
    const url = localStorage.getItem("urlAxioPP");
    const fechaNacimientoISO = convertirFormatoFechaAISO(fechaNac);

    if (!url) {
      mostrarNotificacion(
        true,
        "No se encontro la URL de API (urlAxioPP). Contacte a soporte.",
        "rojo",
      );
      return;
    }

    if (!fechaNacimientoISO) {
      mostrarNotificacion(true, "Fecha de nacimiento invalida", "rojo");
      return;
    }

    try {
      let token = await ensureAppHCToken(url);
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const mutualNombre = getTextoDesplegableSeleccionado(mutuales, mutual);
      const mutualCodigo = Number(mutual);
      const nroDocumentoNormalizado = String(nroDocumento).trim();
      const celularNormalizado = String(celular).trim();
      const mutualAfiliadoNormalizado =
        mutualCodigo === 1 ? "-" : String(mutualAfiliado || "").trim();

      const payload = {
        hc: nroDocumentoNormalizado,
        documentoNro: nroDocumentoNormalizado,
        documentoTipo: tipoDoc,
        documentoTipoNombre: getTextoDesplegableSeleccionado(tiposDoc, tipoDoc),
        nombre: nombre,
        apellido: apellido,
        mutual: Number.isNaN(mutualCodigo) ? mutual : mutualCodigo,
        mutualNombre: mutualNombre,
        telefono: celularNormalizado,
        celular: celularNormalizado,
        email: correo,
        mutualAfiliado: mutualAfiliadoNormalizado,
        nacimiento: fechaNacimientoISO,
        password: nroDocumentoNormalizado,
      };

      let response;
      try {
        response = await axios.post(`${url}Pacientes`, payload, config);
      } catch (errorPrimario) {
        const status = errorPrimario?.response?.status;
        if (status === 401 || status === 403) {
          sessionStorage.removeItem("AppHCToken");
          token = await ensureAppHCToken(url, true);
          config = { headers: { Authorization: `Bearer ${token}` } };
          response = await axios.post(`${url}Pacientes`, payload, config);
        } else {
          throw errorPrimario;
        }
      }

      if (response?.status === 200) {
        mostrarNotificacion(true, "Usuario registrado correctamente", "verde");
        limpiarCampos();
        setTimeout(() => {
          setOpenModal(false);
        }, 2000);
      }
    } catch (error) {
      const mensajeError =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Error desconocido al registrar el paciente";
      mostrarNotificacion(true, "Error: " + mensajeError, "rojo");
    }
  };

  const obtenerPaciente = async () => {
    const url = localStorage.getItem("urlAxioPP");
    let sesion = JSON.parse(sessionStorage.getItem("ppUL"));
    try {
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      const response = await axios.get(
        `${url}Pacientes?documento=${nroDocumento}`,
        config,
      );
      const data = response.data[0];
      sesion = {
        ...sesion,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };
      sessionStorage.setItem("ppUL", JSON.stringify(sesion));
      setPaciente?.(sesion);
      setOpenModal(false);
    } catch (error) {
      console.error("Error en petición obtenerPaciente", error.response);
      mostrarNotificacion(
        true,
        "Se produjo un error al intentar consultar los datos del paciente",
        "rojo",
      );
    }
  };

  const modificarPaciente = async () => {
    const url = localStorage.getItem("urlAxioPP");
    const fechaNacimientoISO = convertirFormatoFechaAISO(fechaNac);
    const fechaNacimientoCompat = convertirFormatoFechaAMesDiaAnio(fechaNac);

    if (!url) {
      mostrarNotificacion(
        true,
        "No se encontro la URL de API (urlAxioPP). Contacte a soporte.",
        "rojo",
      );
      return false;
    }

    if (!fechaNacimientoISO) {
      mostrarNotificacion(true, "Fecha de nacimiento invalida", "rojo");
      return false;
    }

    const nroDocumentoNormalizado = String(nroDocumento || "").trim();
    const celularNormalizado = String(celular || "").trim();
    const correoNormalizado = String(correo || "").trim();
    const mutualCodigo = Number(mutual);
    const mutualAfiliadoNormalizado =
      mutualCodigo === 1 ? "-" : String(mutualAfiliado || "").trim();
    const documentoNumero = /^\d+$/.test(nroDocumentoNormalizado)
      ? Number(nroDocumentoNormalizado)
      : nroDocumentoNormalizado;
    const celularCompat = /^\d+$/.test(celularNormalizado)
      ? Number(celularNormalizado)
      : celularNormalizado;
    const mutualNormalizada = Number.isNaN(mutualCodigo)
      ? mutual
      : mutualCodigo;
    const mutualNombre = getTextoDesplegableSeleccionado(mutuales, mutual);
    const documentoTipoNombre = getTextoDesplegableSeleccionado(
      tiposDoc,
      tipoDoc,
    );

    let config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    const payloadPutMe = {
      codigo: paciente.codigo,
      hc: paciente.hc,
      documentoNro: documentoNumero,
      documentoTipo: tipoDoc,
      documentoTipoNombre,
      nombre: nombre,
      apellido: apellido,
      mutual: mutualNormalizada,
      mutualNombre,
      celular: celularCompat,
      email: correoNormalizado,
      mutualAfiliado: mutualAfiliadoNormalizado,
      nacimiento: fechaNacimientoCompat,
      password: nroDocumentoNormalizado,
    };
    const payloadPorCodigo = {
      ...payloadPutMe,
      telefono: celularNormalizado,
      celular: celularNormalizado,
      nacimiento: `${fechaNacimientoISO}T00:00:00`,
      mutualOtorgaWeb:
        typeof paciente?.mutualOtorgaWeb === "boolean"
          ? paciente.mutualOtorgaWeb
          : true,
    };

    try {
      let response;
      try {
        response = await axios.put(
          `${url}Pacientes/${paciente.codigo}`,
          payloadPorCodigo,
          config,
        );
      } catch (errorPrimario) {
        const status = errorPrimario?.response?.status;
        if ([400, 404, 405, 415, 422, 500, 501].includes(status)) {
          response = await axios.put(
            `${url}Pacientes/PutMe`,
            payloadPutMe,
            config,
          );
        } else {
          throw errorPrimario;
        }
      }

      if (response.status >= 200 && response.status < 300) {
        mostrarNotificacion(true, "Usuario modificado correctamente", "verde");
        await obtenerPaciente();
        return true;
      }

      mostrarNotificacion(true, "No se ha podido modificar el usuario", "rojo");
      return false;
    } catch (error) {
      const detalleRespuesta = error?.response?.data;
      const statusError = error?.response?.status;
      const mensajeError =
        statusError === 405
          ? "La API de Amprosa esta rechazando la actualizacion del paciente (HTTP 405). Este problema es del backend/deployment y no de los datos ingresados."
          : error?.response?.data?.message ||
            (typeof detalleRespuesta === "string" &&
            /<html|<!DOCTYPE/i.test(detalleRespuesta)
              ? `El servidor devolvió ${statusError || "un error"} al intentar actualizar el paciente`
              : detalleRespuesta) ||
            error?.message ||
            "Error desconocido al modificar el paciente";
      mostrarNotificacion(true, "Error: " + mensajeError, "rojo");
      return false;
    }
  };

  const confirmarCancelarRegistro = () => {
    limpiarCampos();
    setOpenModal(false);
  };

  const togleAbrirCerrarCancelarRegistro = () => {
    if (paciente?.codigo) {
      confirmarCancelarRegistro(); // Cierra el modal y limpia los campos
    } else {
      setAbrirModalCancelarRegistro(true); // Abre el diálogo de confirmación
    }
  };

  // Función para manejar el clic en "Grabar y salir"
  const handleClickRegistrarPaciente = async () => {
    if (validarFormRegistroPaciente()) {
      setCargando(true);
      if (paciente?.codigo) {
        await modificarPaciente();
      } else {
        await registrarPaciente();
      }
      setCargando(false);
    }
  };

  // Función para manejar la confirmación de reiniciar sesión
  const handleClickConfirmar = () => {
    window.location.href = "/Login"; // Redirigir al login
  };

  // agregar metodos modal confirmacion y cierre de ventana
  const [error, setError] = useState(false);

  const formatearFecha = (valor) => {
    // Eliminar caracteres no numéricos
    const limpio = valor.replace(/\D/g, "");

    let fechaFormateada = limpio;
    if (limpio.length >= 3 && limpio.length <= 4) {
      // Formato dd/mm
      fechaFormateada = `${limpio.slice(0, 2)}/${limpio.slice(2, 4)}`;
    } else if (limpio.length >= 5 && limpio.length <= 8) {
      // Formato dd/mm/yyyy
      fechaFormateada = `${limpio.slice(0, 2)}/${limpio.slice(
        2,
        4,
      )}/${limpio.slice(4, 8)}`;
    }

    return fechaFormateada;
  };

  const handleFechaChange = (e) => {
    const valorFormateado = formatearFecha(e.target.value);
    setFechaNac(valorFormateado);

    setError(
      valorFormateado.length === 10 && !validarFormatoFecha(valorFormateado),
    );
  };

  return (
    <IonModal
      isOpen={openModal}
      backdropDismiss={Boolean(paciente?.codigo)}
      onDidDismiss={() => setOpenModal(false)}
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            {paciente?.codigo
              ? "Verifique sus datos"
              : "Registrarme como nuevo paciente"}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" id="inbox-list">
        <Row>
          <IonCol
            sizeXs="12"
            sizeMd="6"
            style={{ textAlign: "start" }}
            container
          >
            <CustomInput
              label="Nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              error={errores.nombre}
              id="nombre"
              placeholder="Ingrese su nombre"
              errorHelperText="No se ingreso el nombre"
              disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
          <IonCol sizeXs="12" sizeMd="6" style={{ textAlign: "start" }}>
            <CustomInput
              label="Apellido"
              value={apellido}
              onChange={(e) => setApellido(e.target.value)}
              error={errores.apellido}
              id="apellido"
              placeholder="Ingrese su apellido"
              errorHelperText="No se ingreso el apellido"
              disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
        </Row>

        <Row>
          <IonCol sizeXs="12" sizeMd="6" style={{ textAlign: "start" }}>
            <CustomDesplegable
              array={tiposDoc}
              value={tipoDoc}
              handleChange={handleChangeSelect}
              mostrarTodos={false}
              mostrarSearch={false}
              barraBusqueda={true}
              label="Tipo de documento"
              id="Tipo Documento"
              ocultarLabel={true}
              className={`${errores.tipoDoc && "ion-invalid"}`}
              errorText="No se selecciono un tipo de documento"
              isOpen={abrirDesplegableTiposDoc}
              setIsOpen={setAbrirDesplegableTiposDoc}
              error={errores.tipoDoc}
              placeholder="Seleccione un tipo de documento..."
              errorHelperText="No se selecciono un tipo de documento"
              disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
          <IonCol sizeXs="12" sizeMd="6" style={{ textAlign: "start" }}>
            <CustomInput
              label="Nro de documento"
              value={nroDocumento}
              onChange={(e) => setNroDocumento(e.target.value)}
              error={errores.nroDocumento}
              id="nroDocumento"
              placeholder="Ingrese su nro de documento"
              errorHelperText="No se ingreso un nro de documento"
              disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
        </Row>

        <Row>
          <IonCol sizeXs="12" style={{ textAlign: "start" }}>
            <CustomInput
              label="Fecha de nacimiento"
              value={fechaNac}
              onChange={handleFechaChange}
              error={errores.fechaNac}
              id="fechaNac"
              placeholder="dd/mm/yyyy"
              errorHelperText="No se ingresó una fecha de nacimiento válida"
              type="text"
              inputSlotProps={{
                min: dayjs().subtract(110, "year").format("YYYY-MM-DD"),
                max: dayjs().format("YYYY-MM-DD"),
              }}
              maxLength={10}
            />
          </IonCol>
        </Row>
        <Row>
          <IonCol sizeXs="12" sizeMd="6" style={{ textAlign: "start" }}>
            <CustomInput
              label="Celular"
              value={celular}
              onChange={(e) => setCelular(e.target.value)}
              error={errores.celular}
              id="celular"
              placeholder="Ingrese su nro celular"
              errorHelperText="No se ingreso el nro celular"
              type="number"
              // disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
          <IonCol sizeXs="12" sizeMd="6" style={{ textAlign: "start" }}>
            <CustomInput
              label="Correo"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              error={errores.correo}
              id="correo"
              placeholder="Ingrese su correo"
              errorHelperText="No se ingreso un valido correo"
              type="email"
              // disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
        </Row>
        <Row>
          <IonCol sizeXs="12" sizeMd="6" style={{ textAlign: "start" }}>
            <CustomDesplegable
              array={mutuales}
              value={mutual}
              handleChange={handleChangeSelect}
              mostrarTodos={false}
              mostrarSearch={true}
              barraBusqueda={true}
              label="Obra social"
              id="Obra social"
              ocultarLabel={true}
              className={`${errores.mutual && "ion-invalid"}`}
              isOpen={abrirDesplegableMutuales}
              setIsOpen={setAbrirDesplegableMutuales}
              error={errores.mutual}
              placeholder="Seleccione una obra social..."
              errorHelperText="No se selecciono una obra social"
              disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
          <IonCol sizeXs="12" sizeMd="6" style={{ textAlign: "start" }}>
            <CustomInput
              label="Numero de afiliado"
              value={mutualAfiliado}
              onChange={(e) => {
                setMutualAfiliado(e.target.value);
                setErrores((prev) => ({ ...prev, mutualAfiliado: false }));
              }}
              error={errores.mutualAfiliado}
              id="mutualAfiliado"
              placeholder="Ingrese su nro de afiliado"
              errorHelperText="No se ingreso un nro de afiliado"
              disabled={Boolean(paciente?.codigo) || Number(mutual) === 1}
            />
          </IonCol>
        </Row>
      </IonContent>
      <IonFooter>
        <Row container>
          <IonCol size="6" style={{ textAlign: "start" }}>
            <CustomInput
              value={paciente?.codigo ? "Salir" : "Cancelar registro"}
              onClick={togleAbrirCerrarCancelarRegistro}
              type="button"
              variant="solid"
              color="danger"
              // disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
          <IonCol size="6" style={{ textAlign: "start" }}>
            <CustomInput
              value={paciente?.codigo ? "Grabar y salir" : "Registrarme"}
              onClick={handleClickRegistrarPaciente}
              type="button"
              variant="solid"
              color="success"
              // disabled={Boolean(paciente?.codigo)}
            />
          </IonCol>
        </Row>
      </IonFooter>

      <DialogoConfirmacion
        titulo="Cancelar registro"
        texto="¿Esta seguro de cancelar el registro? Se perderan los datos que haya cargado"
        open={abrirModalCancelarRegistro}
        setOpen={setAbrirModalCancelarRegistro}
        handleClickCancelar={togleAbrirCerrarCancelarRegistro}
        handleClickConfirmar={confirmarCancelarRegistro}
        colorBotonNo="warning"
        colorBotonSi="danger"
        colorDialogo="neutral"
        textoBotonNo="CANCELAR"
        textoBotonSi="ESTOY SEGURO"
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </IonModal>
  );
};

export default ModalPacienteForm;
